import { mutatorAction } from 'satcheljs';
import { MeetingRequestViewState } from '../store/schema/MeetingRequestViewState';

/**
 * @param viewState: The current view State of the notes editor container
 * @param sendresponse: The current state of the toggle which is hooked to the logic to send response or not
 */
export default mutatorAction(
    'onNotifyOrganiserToggled',
    (viewState: MeetingRequestViewState, sendResponse: boolean) => {
        if (viewState && viewState.editorViewState) {
            viewState.editorViewState.sendResponse = sendResponse;
        }
    }
);
